import React, { useState } from "react";
import logo from "../../Images/Bigfreshlogo.png";
import {
  FaTachometerAlt,
  FaUser,
  FaSignOutAlt,
  FaBoxes,
  FaUsersCog,
  FaMoneyBill,
  FaShoppingCart,
  FaGift,
  FaWallet,
  FaEnvelope,
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
  FaQuestionCircle,
} from "react-icons/fa";
import { IoSettings } from "react-icons/io5";
import { useLocation } from "react-router-dom";
import { FaFileLines } from "react-icons/fa6";




const Sidebar = ({ collapsed, setCollapsed }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
 const location = useLocation();
 

  const menuItems = [
    { name: "Dashboard", path: "/dashboard", icon: <FaTachometerAlt /> },
    { name: "Manage Profile", path: "/profile", icon: <FaUser /> },
    { name: "Inventory", path: "/inventory", icon: <FaBoxes /> },
    { name: "Manage Users", path: "/users", icon: <FaUser /> },
    { name: "Team", path: "/team", icon: <FaUsersCog /> },
    { name: "Earning Plan", path: "/earning", icon: <FaMoneyBill /> },
    { name: "Order History", path: "/orders", icon: <FaShoppingCart /> },
    { name: "Transactionhistory", path: "/transaction", icon: <FaWallet /> },
    { name: "Reward", path: "/reward", icon: <FaGift /> },
    { name: "Withdrawal Section", path: "/withdraw", icon: <FaWallet /> },
    { name: "Enquiry Section", path: "/enquiry", icon: <FaQuestionCircle /> },
    {
      name: "Setting", path: "/setting", icon: <IoSettings />
      
    },
       { name:"T & C", path: "/term-condition", icon: <FaFileLines /> },
  ];

  const handleLogout = () => {
    setShowLogoutModal(false);
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace("/login");
  };

  const goTo = (path) => {
    window.location.href = path;
  };

  return (
    <>
      {/* MOBILE HAMBURGER */}
      <button
        type="button"
        className="btn btn-dark d-md-none position-fixed top-0 start-0 m-3"
        style={{ zIndex: 1100 }}
        onClick={() => setMobileOpen(true)}
      >
        ☰
      </button>


      <div
        className="d-none d-md-flex flex-column vh-100 position-fixed bg-success text-white "
        style={{
          width: collapsed ? "90px" : "270px",
          transition: "width 0.3s",
          zIndex: 1000,
          overflow: "hidden",
        }}
      >
  
        <div className="text-center py-4 border-bottom">
          <img src={logo} alt="Logo" width={collapsed ? 45 : 90} />
        </div>

 
        <div
          className="flex-grow-1  sidebar-scroll px-3 d-flex flex-column"
          style={{
            overflowY: "auto",
            paddingRight: "6px",
          }}
        >
    
{menuItems.map((item, i) => {
  const isActive = location.pathname === item.path;

  return (
    <div
      key={i}
      className={`px-2 py-1 d-flex align-items-center ${
        collapsed ? "justify-content-center" : "gap-1"
      }`}
      style={{
        cursor: "pointer",
        borderRadius: "8px",
        margin: "2px 5px",
        backgroundColor: isActive ? "#ffffff" : "transparent",
        color: isActive ? "#198754" : "#ffffff",
        fontWeight: isActive ? "600" : "400",
        transition: "0.2s",
      }}
      onClick={() => goTo(item.path)}
    >
      <span
        style={{
          fontSize: "20px",
          minWidth: "30px",
          textAlign: "center",
        }}
      >
        {item.icon}
      </span>

      {!collapsed && <span>{item.name}</span>}
    </div>
  );
})}

     
          <button
  type="button"
  className={`btn btn-danger mt-auto mb-3 ${
    collapsed
      ? "d-flex justify-content-center align-items-center mx-2"
      : "mx-3"
  }`}
  style={{
    height: "45px",
    padding: collapsed ? "0" : "0.375rem 0.75rem",
  }}
  onClick={() => setShowLogoutModal(true)}
>
  {collapsed ? <FaSignOutAlt /> : <><FaSignOutAlt /> Logout</>}
</button>


        </div>


        <button
          type="button"
          className="btn btn-light position-absolute top-50 end-0 translate-middle-y"
          style={{ borderRadius: "50%" }}
          onClick={() => setCollapsed(!collapsed)}
        >
          {collapsed ? <FaChevronRight /> : <FaChevronLeft />}
        </button>
      </div>

      {/* MOBILE SIDEBAR */}
      {mobileOpen && (
        <>
          <div
            className="position-fixed top-0 start-0 vh-100 w-50 bg-success text-white d-md-none"
            style={{ zIndex: 1200, overflowY: "auto" }}
          >
            <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
              <img src={logo} alt="Logo" width="70" />
              <button
                type="button"
                className="btn btn-light"
                onClick={() => setMobileOpen(false)}
              >
                <FaTimes />
              </button>
            </div>

            <div className="p-3">
              {menuItems.map((item, i) => (
                <div
                  key={i}
                  className="py-3 d-flex align-items-center gap-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    goTo(item.path);
                    setMobileOpen(false);
                  }}
                >
                  <span style={{ minWidth: "30px", textAlign: "center" }}>
                    {item.icon}
                  </span>
                  <span>{item.name}</span>
                </div>
              ))}

              <button
                type="button"
                className="btn btn-danger w-100 mt-3"
                onClick={() => setShowLogoutModal(true)}
              >
                <FaSignOutAlt /> Logout
              </button>
            </div>


            
          </div>

          <div
            className="position-fixed top-0 start-0 w-100 h-100"
            style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1100 }}
            onClick={() => setMobileOpen(false)}
          />
        </>
      )}

      {/* LOGOUT MODAL */}
      <div
        className={`modal fade ${showLogoutModal ? "show d-block" : ""}`}
        tabIndex="-1"
        style={{
          backgroundColor: showLogoutModal ? "rgba(0,0,0,0.5)" : "transparent",
        }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirm Logout</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowLogoutModal(false)}
              />
            </div>

            <div className="modal-body">
              <p>Are you sure you want to logout?</p>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setShowLogoutModal(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
